import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgMoneyDollarSign = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M3 12C3 14.3869 3.94821 16.6761 5.63604 18.364C7.32387 20.0518 9.61305 21 12 21C14.3869 21 16.6761 20.0518 18.364 18.364C20.0518 16.6761 21 14.3869 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12V12Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.2001 13.8001C10.2001 14.1561 10.3056 14.5041 10.5034 14.8001C10.7012 15.0961 10.9823 15.3268 11.3112 15.463C11.6402 15.5993 12.0021 15.6349 12.3512 15.5655C12.7004 15.496 13.0211 15.3246 13.2729 15.0728C13.5246 14.8211 13.696 14.5004 13.7655 14.1512C13.8349 13.8021 13.7993 13.4401 13.6631 13.1112C13.5268 12.7823 13.2961 12.5012 13.0001 12.3034C12.7041 12.1056 12.3561 12.0001 12.0001 12.0001C11.6441 12.0001 11.2961 11.8945 11 11.6967C10.704 11.4989 10.4733 11.2178 10.3371 10.8889C10.2009 10.56 10.1652 10.1981 10.2347 9.84889C10.3041 9.49973 10.4755 9.179 10.7273 8.92726C10.979 8.67553 11.2997 8.5041 11.6489 8.43464C11.9981 8.36519 12.36 8.40083 12.6889 8.53707C13.0178 8.67331 13.2989 8.90402 13.4967 9.20003C13.6945 9.49604 13.8001 9.84405 13.8001 10.2001"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 7.20007V8.40007"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 15.5999V16.7999"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgMoneyDollarSign.displayName = 'SvgMoneyDollarSign';
export default SvgMoneyDollarSign;
